module.exports = __webpack_public_path__ + "assets/101b15a04ad810a0c2837f8f5ff5dce2.png";